import { PublicClientApplication } from '@azure/msal-browser';
import { createMsalConfig } from './msalConfig';

export const msalInstance = new PublicClientApplication(createMsalConfig());

export async function initializeMsal(): Promise<void> {
  await msalInstance.initialize();

  const response = await msalInstance.handleRedirectPromise();

  if (response) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0] ?? null);
    }
  }
}
